import React from 'react'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { IconButton } from '@mui/material'

interface Props {
  direction?: 'forward'
  isDouble?: boolean
  onClick?: () => void
}

const BUTTON_SIZE = 25
const ARROW_SIZE = BUTTON_SIZE / 2

const GridArrowStepperBtn: ReactFC<Props> = ({
  direction,
  isDouble = false,
  onClick
}) => {
  let Arrow = ArrowBackIosNewIcon
  if (direction === 'forward') Arrow = ArrowForwardIosIcon

  const handleClick = () => {
    if (onClick != null) onClick()
  }

  if (isDouble) {
    return (
      <IconButton
        sx={{
          width: `${BUTTON_SIZE}px`, height: `${BUTTON_SIZE}px`
        }}
        onClick={handleClick}
      >
        <Arrow
          sx={{
            fontSize: `${ARROW_SIZE}px`,
            position: 'absolute',
            top: '50%',
            left: '40%',
            transform: 'translate(-50%, -50%)'
          }}
        />
        <Arrow
          sx={{
            position: 'absolute',
            top: '50%',
            left: '60%',
            transform: 'translate(-50%, -50%)',
            fontSize: `${ARROW_SIZE}px`
          }}
        />
      </IconButton>
    )
  }

  return (
    <IconButton
      sx={{
        width: `${BUTTON_SIZE}px`, height: `${BUTTON_SIZE}px`
      }}
      onClick={handleClick}
    >
      <Arrow
        sx={{
          fontSize: `${ARROW_SIZE}px`
        }}
      />
    </IconButton>
  )
}
export default GridArrowStepperBtn
